<script setup>
import SelectInput from '@/components/shared/form/SelectInput.vue'
import {languageOptions} from '@/constants/languages.js'

//Emits and props
defineEmits([
  'input',
  'dirty',
])
defineProps({
  languages: {
    type: Array,
    default: () => languageOptions,
  },
})
</script>

<template>
  <SelectInput
    v-bind="$attrs"
    :options="languages"
    aria-label="Language"
    placeholder="Select a language"
    is-filterable
    @input="$emit('input', $event)"
    @dirty="$emit('dirty', $event)"
  />
</template>
